import { Form, Row, Col } from 'react-bootstrap';
import { usePortalContext } from '../../lib/context/portalContext';
import dateFormat from '../../lib/dateFormat';

const STATUS = {
  P: 'Active',
  N: 'Pending',
  C: 'Completed',
  X: 'Cancelled',
};

const AccountDetails = (props) => {
  const {rowData} = usePortalContext();
  
  return (
    <div className="offcanvas-form">
      <Form className="mb-3">
        <Row>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label>Subscription Type</Form.Label>
              <Form.Control
                defaultValue={rowData?.type === 'AS' ? 'Fulcrum' : rowData?.type}
                readOnly
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                defaultValue={dateFormat(rowData?.start_time)}
                readOnly
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Expiration</Form.Label>
              <Form.Control
                defaultValue={dateFormat(rowData?.end_time)}
                readOnly
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control
                defaultValue={STATUS[rowData?.status]}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AccountDetails;
